# Конфигуратор,
# Доступность в ресторанах
App.ArrayOfObjectsTransform = DS.Transform.extend
  deserialize: (serialized) ->
    return null if not Em.isArray(serialized)

    serialized.map (obj) ->
      Em.Object.create(obj)


  serialize: (deserialized) ->
    array = deserialized

    return null if !array

    # Пустой конфигуратор сериализуется как null
    if array.get('length') > 0 then array else null


